import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-terminal-icon',
  templateUrl: './code-terminal.component.html'
})
export class CodeTerminalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
